export const AUDIT_LOGS_INPUT_HEIGHT: number = 1100
